<template>
    <main role="main" id="app" v-cloak :class="injectPrivilegeClassName({ appDownload: appDownload })">
        <app-download
            ref="appdownload"
            :show-bar-params="showBarParams"
            v-bind:app-download.sync="appDownload"
            v-if="!isSourceChannel && !shareHash"
        >
        </app-download>
        <div class="cz-page" v-if="pageInfo.product">
            <FadeInHeader
                :startOffset="0"
                :backgroundImage="pageInfo.product.backgroundImg ? pageInfo.product.backgroundImg : ''"
                :events="events"
            >
                <div class="mini-logo-wrapper" slot="title-1">
                    <img :src="pageInfo.product.logo" />
                    <div class="product-title">{{ pageInfo.product.name }}</div>
                </div>
            </FadeInHeader>
            <img v-if="pageInfo.product.backgroundImg" class="tips-background" :src="pageInfo.product.backgroundImg" />
            <ImmersionHead :events="events" :zIndex="100" />
            <div class="logo-wrapper" :class="{ h5: !isApp }">
                <img class="logo" :src="pageInfo.product.logo" />
            </div>
            <div class="product-name" v-if="!currentSkuIsRenewPrice">{{ pageInfo.product.name }}</div>
            <div class="new-tips">
                <div class="main-title" v-if="currentSkuIsRenewPrice">
                    <div class="title-wrapper">
                        <p>您已是会员，现在续费享会员续费折扣</p>
                        <img :src="tipsIcon" class="tips-icon" @click="isShowRenewConflict = true" />
                    </div>
                    <time-down
                        class="time-down"
                        v-if="renewBuyInfo && renewBuyInfo.expiredAt"
                        :end-time="renewBuyInfo && renewBuyInfo.expiredAt"
                        @finish="finishTimedown"
                    />
                </div>
                <div class="sub-title">
                    <div
                        class="auto-tips"
                        v-if="
                            pageInfo.skuList &&
                                pageInfo.skuList[categoryIndex] &&
                                pageInfo.skuList[categoryIndex].signed_account
                        "
                    >
                        <span>您的账号</span>
                        <span class="auto-tips-num">{{ pageInfo.skuList[categoryIndex].signed_account }}</span>
                        <span>已开通自动续费</span>
                    </div>
                </div>
            </div>

            <!-- 新版 -->
            <reminder-banner
                class="reminder-banner"
                v-if="mark"
                :mark="mark"
                v-bind:show-reminder.sync="showReminder"
            ></reminder-banner>
            <section
                class="swiper-mine"
                v-if="!isJobConvenienceAliMini && multiPositions['recharge_detail_top_banner']"
            >
                <swiper :options="swiperOption1" ref="mySwiper1">
                    <swiper-slide
                        v-for="(slideItem, slideIndex) in multiPositions['recharge_detail_top_banner']"
                        :key="slideIndex"
                    >
                        <img
                            :src="slideItem.contentObj.img"
                            class="swiper-mine-img"
                            @click="skipToUrl(slideItem.contentObj.url)"
                        />
                    </swiper-slide>
                </swiper>
            </section>
            <div class="content" v-if="pageInfo.product && pageInfo.product.placeholder">
                <label for="phone">
                    <div class="warning-title">
                        <img src="../../../blackcard/images/common/icon-warning.png" />
                        请确保账号无误，充值成功后不支持退换
                    </div>
                    <div class="content-title" v-if="flatedGameForm && flatedGameForm.length">
                        <span class="title-text">充值账号</span>
                    </div>
                    <div class="input" v-if="!signed_account">
                        <input
                            :type="inputType == 'username' ? 'text' : 'tel'"
                            v-model="formatPhone"
                            @blur="inputOnBlur"
                            :maxlength="inputType == 'phone' ? '15' : '25'"
                            id="phone"
                            @focus="inputOnFocus"
                            @input="inputOnInput"
                            @click="dealInputPosition"
                            @keyup="dealButtonInputPosition"
                            @touchend="dealInputPosition"
                            :placeholder="pageInfo.product.placeholder"
                            :class="{ error: isError }"
                        />
                        <i @click="delInputStr" class="input-close" v-show="isShowDel"></i>
                    </div>
                    <div class="input" v-else>
                        <span class="input-text">{{ signed_account }}</span>
                    </div>
                    <div v-if="isError && phone" class="error-tips">{{ errorTips }}</div>
                    <RechargeSuccessAccount
                        :class="{ game: flatedGameForm && flatedGameForm.length }"
                        :type="inputType"
                        :product-id="id"
                        :visable.sync="showRechargeSuccessAccount"
                        :current.sync="formatPhone"
                    />
                </label>
                <div class="line" v-if="flatedGameForm && flatedGameForm.length"></div>
                <game-form
                    :form-data="filteredFlattenGameForm"
                    v-if="flatedGameForm && flatedGameForm.length"
                    @click-form-item="handleClickFormItem"
                ></game-form>
                <popup-picker
                    class="popup-picker"
                    :show="pickerShow"
                    :value="pickerFormItem.value"
                    :options="pickerFormItem.options"
                    :title="pickerFormItem.label"
                    @change="handlePick"
                    @input="handleClosePicker"
                ></popup-picker>
            </div>
            <div :class="{ mb20: !tipsImage }" v-if="shouldShowInApp && !isJobConvenienceAliMini">
                <AllowanceTips :allowance="allowance" :shouldShow="shouldShowInApp" @click.native="handleTrackClick" />
            </div>
            <CouponList
                :couponList="couponList"
                :isSourceChannel="isSourceChannel"
                :showOverMask="showOverMask"
                @open="openCouponList"
            />

            <MemberList
                :hasUnion="hasUnion"
                :pageInfo="pageInfo"
                :categoryDetailList="categoryDetailList"
                :categoryIndex="categoryIndex"
                :isCY="isCY"
                :isSC_CY="isSC_CY"
                :isSourceChannel="isSourceChannel"
                :productIndex="productIndex"
                :showTips="showTips"
                @select="changeProductIndex"
                @switch="changeCategoryIndex"
                @close-tips="showTips = false"
            />

            <section
                class="swiper-mine"
                v-if="!isJobConvenienceAliMini && multiPositions['recharge_detail_bottom_banner']"
            >
                <swiper :options="swiperOption2" ref="mySwiper2">
                    <swiper-slide
                        v-for="(slideItem, slideIndex) in multiPositions['recharge_detail_bottom_banner']"
                        :key="slideIndex"
                    >
                        <img
                            :src="slideItem.contentObj.img"
                            class="swiper-mine-img"
                            @click="skipToUrl(slideItem.contentObj.url)"
                        />
                    </swiper-slide>
                </swiper>
            </section>
            <Tips :content="pageInfo.product && pageInfo.product.rule" />

            <div class="btn-area">
                <div
                    class="auto-rule"
                    :class="{ 'auto-rule-animation': showRuleAnimation }"
                    @animationend="() => (showRuleAnimation = false)"
                >
                    <template v-if="productActiveObj.payment_cycle > 0">
                        <van-checkbox
                            v-model="isCheckAutoRule"
                            class="auto-rule-check"
                            checked-color="#EE9F5C"
                        ></van-checkbox>
                        <div class="auto-rule-msg">
                            同意<a href="https://m.black-unique.com/slime/pages/2450/index.html?ZZCAppArg=appopenpage"
                                >《自动续费协议》</a
                            >，到期自动续费，可随时取消
                        </div>
                    </template>
                    <div v-else class="auto-rule-msg">
                        开通前请仔细阅读<a
                            href="https://m.black-unique.com/slime/pages/4636-FD16C103/index.html?ZZCAppArg=appopenpage"
                            >《虚拟服务购买协议》</a
                        >
                    </div>
                </div>
                <!-- 放开ios限制 v-mini-program-click="mpDownloadAppParams" -->
                <div class="btn-area-inner">
                    <a @click="showService" class="btn-area-service">
                        <img class="service-image" src="../../images/icon-service-new.png" alt="" />
                        <span class="service-text">客服</span>
                    </a>
                    <span @click="linkToDetail" style="color:#4A90E2" class="btn-area-order">
                        <img class="order-image" src="../../images/icon-check-order-new.png" alt="" />
                        <span class="service-text">订单</span>
                    </span>

                    <!--  确定购买按钮  -->
                    <div class="btn-container">
                        <template v-if="isStopSale">
                            <div class="submit-btn disable" @click="submit">特权太火爆，已被抢光了</div>
                        </template>
                        <template v-else-if="hasAutoCouponStatus">
                            <div class="submit-btn-coupon" @click="submit">
                                <p v-if="productActiveObj.payment_cycle > 0 && !isCheckAutoRule" class="submit-text">
                                    确认协议并支付
                                </p>
                                <p v-else class="submit-text">
                                    {{ getCouponBuyText }}
                                    <span class="submit-symbol">¥</span>
                                    <span class="submit-price">{{ priceAfterCoupon }}</span>
                                </p>
                                <!-- <p class="price-text">券后 ¥{{ priceAfterCoupon }}</p> -->
                            </div>
                        </template>
                        <template v-else>
                            <div class="submit-btn" @click="submit">
                                {{
                                    productActiveObj.payment_cycle > 0 && !isCheckAutoRule
                                        ? '确认协议并支付'
                                        : submitText
                                }}
                            </div>
                        </template>
                    </div>

                    <template v-if="showPriceTips && oldPrice > newPrice">
                        <div class="price-tips" v-if="currentBestPrice && !isSourceChannel">
                            {{
                                productActiveObj.showPrice > currentBestPrice
                                    ? `实际到手价${currentBestPrice}元`
                                    : `立省 ${(oldPrice - currentBestPrice) | formatPrice} 元`
                            }}
                        </div>
                        <div class="price-tips" v-else>
                            <template
                                v-if="!productActiveObj.showPrice || productActiveObj.showPrice < currentBestPrice"
                            >
                                <template v-if="isSC_CY">券后</template> 立省{{
                                    (oldPrice - newPrice) | formatPrice
                                }}元</template
                            >
                            <template v-else>
                                {{ `实际到手价${newPrice}元` }}
                            </template>
                        </div>
                    </template>
                </div>
            </div>

            <!-- 领取优惠券列表组件 -->
            <user-get-coupon-list
                v-if="productActiveObj && productActiveObj.couponList"
                v-model="isShowCouponList"
                :canReceiveCouponList="productActiveObj.couponList"
            />
        </div>

        <section class="coupon-pop" v-if="showCouponPop">
            <div class="coupon-pop-container">
                <i class="container-icon"></i>
                <div class="container-title">
                    <p class="title">爱奇艺优惠活动</p>
                </div>
                <p class="container-text" v-if="couponSku.sku_no == 272">
                    恭喜您获得<br />爱奇艺黄金会员<span class="container-text-light">年卡99元</span
                    >(原价198元)<br />的专享优惠资格！ 恭喜您获得<br />爱奇艺黄金会员<span class="container-text-light"
                        >年卡99元</span
                    >(原价198元)<br />的专享优惠资格！
                </p>
                <p class="container-text" v-else>
                    恭喜您获得<br />爱奇艺钻石会员<span class="container-text-light">月卡15元</span
                    >(原价50元)<br />的专享优惠资格！
                </p>
                <div class="container-button">
                    <span class="submit" @click="submitDiscount">立即购买</span>
                    <span class="cancel" @click="cancelDiscount">放弃优惠</span>
                </div>
            </div>
        </section>

        <!--客服弹窗-->
        <service-pop
            :custom-call-list="customPhoneList"
            :online-service-url="'/privilege_module/index?ZZCAppArg=AppOpenPage&key=kf&_page=chat&chat_id=0'"
            :show="isShowService"
            :is-use-ali-service="true"
            ali-service-type="PRIVILEGE_RECHARGE"
            @close="closeService"
        >
        </service-pop>

        <popup :is-show="isShowFirstPop">
            <div class="popup-wrap">
                <div class="popup-container-title">
                    <h3 class="title">温馨提示</h3>
                </div>
                <div class="popup-container-content">
                    <img class="content-image" :src="popImg" alt="" />
                </div>
                <div class="popup-footer">
                    <button class="popup-footer-btn" @click="firstPopSubmit">我知道了</button>
                </div>
            </div>
        </popup>

        <popup :is-show="isShowSecPop">
            <div class="popup-wrap popup__buy">
                <i class="popup-icon"></i>
                <div class="popup-container-title">
                    <h3 class="title">优惠活动</h3>
                </div>
                <div class="popup-container-content">
                    <img class="content-image" :src="popImg" alt="" />
                </div>
                <div class="popup-footer">
                    <button class="popup-footer-btn cancel" @click="secPopCancel">放弃优惠</button>
                    <button class="popup-footer-btn" @click="secPopSubmit">立即购买</button>
                </div>
            </div>
        </popup>
        <!-- <popup :is-show="showAutoRulePop" @close="showAutoRulePop = false">
            <div class="popup-wrap">
                <div class="popup-container-title">
                    <h3 class="title">确认开通</h3>
                </div>
                <div class="popup-container-content">
                    <div class="content-text content-text-auto">
                        请阅读并同意<a
                            href="https://m.black-unique.com/slime/pages/2450/index.html?ZZCAppArg=appopenpage"
                            >《自动续费协议》</a
                        >
                    </div>
                </div>
                <button class="auto-popup-footer-btn" @click="autoRulePopClickHandle">继续购买</button>
            </div>
        </popup> -->

        <!--  优惠券与续费专享优惠不可同享  -->
        <popup :is-show="isShowRenewConflict">
            <div class="popup-wrap">
                <div class="popup-container-title">
                    <h3 class="title">温馨提示</h3>
                </div>
                <div class="popup-container-content">
                    <div class="content-text">优惠券与续费专享优惠不可同享</div>
                </div>
                <div class="popup-footer">
                    <button class="popup-footer-btn" @click="isShowRenewConflict = false">我知道了</button>
                </div>
            </div>
        </popup>

        <disaster-notice-bar :page-id="7"></disaster-notice-bar>

        <share-btn
            :bi-tj-data="tjData"
            :isAutoGetShareInfo="false"
            :business="`recharge`"
            :showTips="true"
            ref="share"
        />

        <memberWall ref="memberWall" :isShowButton="isNotMember" @user-isn-member="handleIsNotMember" />

        <jump-to-alipay-cert
            v-if="isApp && signUrl"
            v-model="showJumpToAlipay"
            :phone="phone"
            @time-after="handleJumpToAliVerify"
        />
        <alipay-cert-check
            v-if="isApp"
            v-model="showAliIdCheck"
            @cert-finished="handleQueryCertStatusByClick"
            @cert-unfinished="handleQueryCertStatusByClick"
        />
        <alipay-cert-fail v-if="isApp" v-model="alipayVerifyFail" :phone="phone" />
    </main>
</template>

<script>
import App from './AppV2.js';
export default App;
</script>

<style lang="scss">
@import './App.scss';
html,
body {
    background: #f2f2f2 !important;
}
.cz-page {
    .tips-background {
        height: 4.2rem;
        width: 100%;
        max-width: 750px;
        z-index: 0;
        position: fixed;
        top: 0;
    }
    .mini-logo-wrapper {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0.24rem;
        img {
            width: 0.46rem;
            height: 0.46rem;
            margin-right: 0.16rem;
            border-radius: 0.08rem;
            background: #fff;
        }
        .product-title {
            line-height: 0.48rem;
            font-size: 0.32rem;
            font-weight: 600;
        }
    }
    .logo-wrapper {
        position: relative;
        width: 100%;
        text-align: center;
        margin-top: -0.88rem;
        &.h5 {
            padding-top: 0.24rem;
        }
        .logo {
            text-align: center;
            width: 0.88rem;
            height: 0.88rem;
            border-radius: 0.16rem;
            vertical-align: bottom;
            background: #fff;
        }
    }
    .product-name {
        width: 100%;
        position: relative;
        text-align: center;
        line-height: 0.48rem;
        margin-top: 0.24rem;
        font-size: 0.32rem;
        font-weight: 600;
    }
    .new-tips {
        position: relative;
        .main-title {
            .title-wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 0.32rem;
                font-weight: 600;
                line-height: 0.48rem;
                margin-top: 0.24rem;
                .tips-icon {
                    width: 0.32rem;
                    height: 0.32rem;
                    margin-left: 0.08rem;
                }
            }
            .time {
                .symbol {
                    font-size: 0.28rem;
                    color: rgba(0, 0, 0, 0.4);
                }
                .number {
                    background: transparent;
                    font-size: 0.28rem;
                    color: #ff4b21;
                    font-weight: 600;
                    margin: 0;
                    margin-left: 0.08rem;
                    padding: 0;
                }
                .text {
                    font-size: 0.28rem;
                    color: #ff4b21;
                    font-weight: 600;
                    margin-right: 0.08rem;
                }
                &::before {
                    font-size: 0.28rem;
                    color: rgba(0, 0, 0, 0.4);
                }
                &::after {
                    font-size: 0.28rem;
                    color: rgba(0, 0, 0, 0.4);
                }
            }
        }
        .sub-title {
            .auto-tips {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 0.28rem;
                margin-top: 0.08rem;
                color: rgba(0, 0, 0, 0.4);
            }
        }
    }
    .reminder-banner {
        position: relative;
        width: 7.02rem;
        margin: 0 auto 0.16rem auto;
        border-radius: 0.16rem;
    }

    .swiper-mine {
        box-sizing: border-box;
        position: relative;
        width: 7.02rem;
        height: 1.6rem;
        margin: 0 auto;
        margin-top: 0.16rem;
        border: 0.04rem solid #ffffff;
        border-radius: 0.16rem;
        .swiper-container {
            width: 100%;
            height: 100%;
        }
        .swiper-mine-img {
            width: 100%;
            height: 100%;
            border-radius: 0;
            object-fit: cover;
            vertical-align: bottom;
            border-radius: 0.16rem;
        }
        .swiper-mine-pagination {
            position: absolute;
            bottom: 0.12rem;
            z-index: 1;
            margin-bottom: 0;
        }
        .swiper-pagination-bullet {
            width: 0.12rem;
            height: 0.08rem;
            background: rgba(255, 255, 255, 0.5);
            transform: skewX(-25deg);
            display: inline-block;
            margin: 0 0.03rem;
            border-radius: 0;
            opacity: 0.56;
        }
        .swiper-pagination-bullet-active {
            opacity: 1;
            background: #fff;
            width: 0.2rem;
            height: 0.08rem;
        }
    }
    .content {
        margin: 0.16rem 0.24rem 0 0.24rem;
        padding: 0.24rem 0.24rem 0.14rem 0.24rem;
        border-radius: 0.16rem;
        .content-title {
            margin-top: 0.16rem;
            font-size: 0.28rem;
        }
        .warning-title {
            display: flex;
            line-height: 0.4rem;
            font-size: 0.28rem;
            color: #b3662e;
            img {
                width: 0.32rem;
                height: 0.32rem;
                vertical-align: middle;
                margin-top: 0.04rem;
                margin-right: 0.08rem;
            }
        }
        .input {
            height: 0.72rem;
            line-height: 0.72rem;
            padding: 0.12rem 0;
            margin-top: 0.18rem;
            #phone {
                height: 0.72rem;
                font-size: 0.56rem;
                font-weight: 600;
                font-family: FinancialNumber;
                line-height: 0.72rem;
                &::-webkit-input-placeholder {
                    font-size: 0.44rem;
                    font-weight: 400;
                    line-height: 0.72rem;
                    color: #cccccc;
                    font-family: -apple-system, PingFang SC, Helvetica, arial, sans-serif;
                }
                &.error {
                    color: #ff4b21;
                    &::-webkit-input-placeholder {
                        color: #ff4b21;
                    }
                }
            }
            .input-text::-webkit-input-placeholder {
                color: #cccccc;
            }
            .intput_writable::-webkit-input-placeholder {
                color: #cccccc;
            }
            .input-close {
                width: 0.48rem;
                height: 0.48rem;
                background: url('../../images/icon-input-delete-V2.png');
                background-size: 100%;
            }
        }
        .error-tips {
            padding-left: 0.35rem;
            position: relative;
            color: #ff4b21;
            font-size: 0.28rem;
            padding-bottom: 0.1rem;
            &:after {
                width: 0.32rem;
                height: 0.32rem;
                content: '';
                background: url(../../images/iocn-new-error.png) no-repeat center;
                background-size: 100%;
                position: absolute;
                top: 0.042rem;
                left: 0;
            }
        }
        .line {
            background: #f0f0f0;
        }
        .game-form {
            .cell-box {
                padding-top: 0.16rem;
                .content-title {
                    margin-top: 0px;
                }
                .input-text {
                    font-weight: 600;
                    &.placeholder {
                        font-weight: 400;
                        color: #ccc;
                    }
                }
                .input-link {
                    width: 0.32rem;
                    height: 0.32rem;
                    background: url('../../images/icon-arrow-right-V2.png') center center / auto 100% no-repeat;
                }
            }
            &:last-child {
                .line {
                    background: transparent;
                }
            }
        }
    }
    .btn-area {
        border-top: 0.01rem solid #f0f0f0;
        box-shadow: none;
        flex-direction: column;
        .auto-rule {
            width: 100%;
            height: 0.62rem;
            background: #ffffff;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding-left: 0.21rem;
            color: #999999;
            line-height: 0.3rem;
            font-size: 0.22rem;
            &-check {
                margin-right: 0.11rem;
            }
            &-msg {
                a {
                    color: #000000;
                }
            }
        }
        .auto-rule-animation {
            animation: shake 1.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
            transform-origin: center;
        }
        @keyframes shake {
            10%,
            90% {
                transform: translate3d(-2px, 0, 0);
            }

            20%,
            80% {
                transform: translate3d(4px, 0, 0);
            }

            30%,
            50%,
            70% {
                transform: translate3d(-8px, 0, 0);
            }

            40%,
            60% {
                transform: translate3d(8px, 0, 0);
            }
        }
        &.wrap {
            display: block;
        }

        .btn-area-inner {
            display: flex;
            width: 100%;
            background: #fff;
        }

        .btn-area-service {
            width: 0.8rem;
            height: 1.12rem;
        }
        .submit-btn-coupon {
            background: linear-gradient(127deg, #2c2928 0%, #000000 100%);
            color: #ffd4af;
            width: 5.58rem;
        }
        .submit-btn {
            background: linear-gradient(127deg, #2c2928 0%, #000000 100%);
            color: #ffd4af;
            width: 5.58rem;
        }
        .submit-text {
            font-size: 0.28rem;
            .submit-symbol {
                margin-right: 0.04rem;
                font-family: FinancialNumber;
            }
            .submit-price {
                font-size: 0.4rem;
                font-weight: 600;
                line-height: 0.48rem;
                font-family: FinancialNumber;
            }
        }
        .price-tips {
            width: auto;
            height: auto;
            padding: 0.1rem 0.16rem;
            border-top-left-radius: 1rem;
            background: #ff4b21;
            font-weight: 600;
            line-height: 0.32rem;
            font-size: 0.2rem;
        }
        .btn-area-order {
            width: 0.72rem;
            height: 1.12rem;
        }
        #common--collect {
            width: 0.72rem;
        }
    }

    .coupon-list {
        position: relative;
        .coupon-view {
            .coupon {
                .production-coupon {
                    height: 0.4rem;
                    line-height: 0.4rem;
                }
            }
        }
    }
}

/* 华为折叠样式兼容 */
/* 展开状态（内屏） */
/* 宽高比 华为二折叠到三折叠 */
@media (min-aspect-ratio: 712/799) and (max-aspect-ratio: 1068/799) {
    .cz-page .member-list .list {
        padding-top: 0.8rem;
    }
}
</style>
